import React from 'react';

const { Provider: GetServiceProvider, Consumer: GetServiceConsumer } = React.createContext();

export { GetServiceProvider, GetServiceConsumer };
